(function ($) {
    'use strict';

    var classCollapsed = 'sn-collapsed',
        generateId = window.dk.generateId,
        scrollTop;

    function unpushMenu() {
        $('.site-wrap').removeClass('pushed');
        $('body').removeClass('modal-open');
        if (scrollTop !== undefined) {
            $(window).scrollTop(scrollTop);
        }

        // Fix bouncing sticky nav
        window.setTimeout(function () {
            $('#main-header').removeClass('nst');
        }, 50);

        $('.context-menu-button').removeClass('active');
        $('.page-mask').off('click');
    }

    function pushMenu() {
        $('.page-mask').on('click', function (e) {
            e.preventDefault();
            unpushMenu();
        });

        // Fix bouncing sticky nav
        $('#main-header').removeClass('offscreen sticky').addClass('nst');

        $('.site-wrap').addClass('pushed');
        scrollTop = $(window).scrollTop();
        $('body').addClass('modal-open');
        $('.context-menu-button').addClass('active');
    }

    function getButtonTitleAndLabel($item, isCollapsed) {
        var pageName = $item.text().replace(/\s{2,}/ig, ' '), label, title;
        isCollapsed = typeof isCollapsed === 'boolean' ?
            isCollapsed : $item.parents('li:first').is(classCollapsed);
        label = isCollapsed ? 'Show' : 'Hide';
        title = label + ' child pages for ' + pageName;
        return { l: label, t: title };
    }

    function bindSideMenu() {
        $('.dk-sidenav').each(function () {
            var $ctr = $(this),
                $parents = $('> ul > li', $ctr).filter(function () {
                    return $(this).find('ul').length > 0;
                });
            if ($parents.length > 0) {
                $('> ul', $ctr).addClass('sn-expandable');
                $parents.each(function () {
                    var $li = $(this),
                        $item = $('>:first', $li),
                        ulId = generateId('sn-ul-'),
                        isCurrent = $li.is('.sn-current'),
                        isDefaultExpanded = $li.is('.sn-default-expanded'),
                        isCollapsed = !isCurrent && !isDefaultExpanded,
                        titleLabel = getButtonTitleAndLabel($item, isCollapsed),
                        $button = $('<button/>').attr({
                            'aria-owns': ulId,
                            'aria-haspopup': 'true',
                            'title': titleLabel.t,
                            'aria-label': titleLabel.l
                        }),
                        $div = $('<div/>').append(
                            $item,
                            $button
                        );
                    $li.prepend($div);
                    $('ul', $li).attr({
                        'id': ulId,
                        'aria-expanded': (!isCollapsed).toString()
                    });
                    if (isCollapsed) {
                        $li.addClass(classCollapsed);
                    }
                    $button.on('click', function (e) {
                        var $btn = $(this),
                            $l = $btn.parents('li:first'),
                            $ul = $('ul:first', $l),
                            isColl = $l.hasClass(classCollapsed);
                        e.preventDefault();
                        $ul[isColl ? 'slideDown' : 'slideUp'](300, function () {
                            var isC = $li.toggleClass(classCollapsed).hasClass(classCollapsed),
                                btnTitleLabel = getButtonTitleAndLabel($item, isC);
                            $btn.attr({
                                'title': btnTitleLabel.t,
                                'aria-label': btnTitleLabel.l
                            });
                            $ul.attr('aria-expanded', (!isC).toString());
                        });
                        return false;
                    });
                });
            }
        });
    }

    function populateGlobal() {
        var $sidenavUl = $('<ul/>'),
            homeLink = $('.site-logo:first').parents('a[href]:first').attr('href');

        function appendLiToMenu() {
            var $navTab = $(this),
                $navTabLink = $('a:first', $navTab),
                $ul = $('<ul/>'),
                $li = $('<li class="sn-collapse"/>'),
                keys = [],
                map = {},
                groupCount = 0;

            if ($navTab.is('.current')) {
                $li.addClass('current');
            }
            $('li', $navTab).each(function () {
                var $item = $(this),
                    $group = $item.parent(),
                    groupName = $group.attr('data-group') || ($group.hasClass('.mn-group') ? 'Group' : ++groupCount);
                if ($.inArray(groupName, keys) < 0) {
                    keys.push(groupName);
                    map[groupName] = [];
                }
                map[groupName].push($item.clone());
            });
            $.each(keys, function (i, v) {
                var title = keys[i],
                    $items = map[v];
                if (typeof title === 'number') {
                    $ul.append($items);
                } else {
                    $ul.append(
                        $('<li class="sn-subsection">').append(
                            $('<div/>').text(title),
                            $('<ul/>').append($items)
                        )
                    );
                }
            });
            $li.append(
                $navTabLink.clone().text(($navTabLink.text() || '').trim()),
                $ul
            ).appendTo($sidenavUl);
        }

        // Add home link (with URL from the site logo)
        $sidenavUl.append(
            $('<li><a href="' + homeLink + '">Home</a></li>')
        );

        $('#site-nav > li').each(appendLiToMenu);
        $('ul.addl-menu-links li').each(appendLiToMenu);

        $('.dk-sidenav').empty().append($sidenavUl);

        bindSideMenu();
    }

    // Document ready
    $(function () {

        $(window).bind('pageshow', function (event) {
            if (event.originalEvent.persisted) {
                window.location.reload();
            }
        });


        unpushMenu();
        populateGlobal();
        $('.page-mask').append(
            $('<div class="close-nav" title="Close navigation"/>')
        );

        $('.dk-nav-menu').on('click', function (e) {
            e.preventDefault();
            pushMenu();
            return false;
        });
    });

})(window.jQuery);
